<div class="container-fluid p-4">
  <div class="row">
    <div class="content m-3">
      <div class="d-flex flex-column text-center justify-content-center">
        <div class="my-3">
          <div class="fullscreen-loader" *ngIf="isGenerating">
            <div class="spinner-ring">
              <div class="spinner-box">
                <div class="custom-arc-spinner"></div>
                <div class="spinner-center-icon">
                  <svg *ngIf="currentCenterIcon === 'lucide-brain'" xmlns="http://www.w3.org/2000/svg" width="30"
                    height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-brain">
                    <path d="M12 5a3 3 0 1 0-5.997.125 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588A4 4 0 1 0 12 18Z" />
                    <path d="M12 5a3 3 0 1 1 5.997.125 4 4 0 0 1 2.526 5.77 4 4 0 0 1-.556 6.588A4 4 0 1 1 12 18Z" />
                    <path d="M15 13a4.5 4.5 0 0 1-3-4 4.5 4.5 0 0 1-3 4" />
                    <path d="M17.599 6.5a3 3 0 0 0 .399-1.375" />
                    <path d="M6.003 5.125A3 3 0 0 0 6.401 6.5" />
                    <path d="M3.477 10.896a4 4 0 0 1 .585-.396" />
                    <path d="M19.938 10.5a4 4 0 0 1 .585.396" />
                    <path d="M6 18a4 4 0 0 1-1.967-.516" />
                    <path d="M19.967 17.484A4 4 0 0 1 18 18" />
                  </svg>
                  <i *ngIf="currentCenterIcon !== 'lucide-brain'" class="bi" [ngClass]="currentCenterIcon"
                    style="font-size: 30px;"></i>
                </div>
              </div>
            </div>
            <div>
              <p class="fs-5 fw-medium m-0 mt-2">Crafting Your Roadmap</p>
              <span class="loader-step-text">{{ loaderMessage }}</span>
            </div>
            <div class="d-flex align-items-center gap-2">
              <div class="loader-progress-wrap">
                <div class="loader-progress-bar" [style.width.%]="loaderProgress"></div>
              </div>
              <span class="loader-progress-pct">{{ loaderProgress | number:'1.0-0' }}%</span>
            </div>

            <div class="loader-steps-list mt-3">
              <ng-container *ngFor="let step of loaderStepsList; let i = index">
                <div class="loader-step-row" [class.active]="i === activeLoaderStep"
                  [class.done]="i < activeLoaderStep">
                  <span class="loader-step-icon">
                    <i class="bi" [ngClass]="i < activeLoaderStep ? 'bi-check-circle-fill' : step.icon"></i>
                  </span>
                  <span class="loader-step-label">{{ step.label }}</span>
                </div>
                <div *ngIf="i === 1" class="w-100"></div>
              </ng-container>
            </div>
            <p class="border fs-6 rounded px-3 py-2 mt-2 fw-medium text-secondary w-100" style="max-width: 500px;"
              *ngIf="generatingRoadmap">
              "{{ generatingRoadmap }}"
            </p>
            <div class="loader-tips-list mt-4">
              <div class="loader-tip-item rounded" *ngFor="let tip of [loaderTips[currentTipIndex]]">
                {{ tip }}
              </div>
            </div>

            <span class="text-secondary loader-text" style="font-size: 10px;">
              🔒 Please stay on this page — your roadmap is being built!
            </span>
          </div>

          <div class="heading">
            <p class="px-3 py-2 rounded-pill">
              <span><i class="bi bi-stars"></i></span>AI-Powered Learning Path
            </p>

            <h1 class="fs-1">
              Build Your Learning <span class="roadmapText">Roadmap</span>
            </h1>
          </div>
          <span class="text-secondary m-5">
            Generate a step-by-step learning path tailored to your goals
          </span>
          <div class="rounded-3 mt-5 border border-border p-4 shadow-lg bg-white mx-auto position-relative"
            style="max-width: 700px">
            <textarea class="rounded-3 w-100 h-auto form-control double-focus"
              placeholder="Describe your learning goals, interests, and preferred topics..." rows="4"
              [(ngModel)]="userPrompt" (input)="isPromptInvalid = false"
              [class.border-danger]="isPromptInvalid"></textarea>
            <div *ngIf="isPromptInvalid" class="text-danger small mt-1">
              Please enter at least 10 characters to generate a roadmap.
            </div>
            <hr />

            <!-- Footer -->
            <div class="d-flex flex-column flex-md-row 
              align-items-center 
              justify-content-center justify-content-md-between 
              text-center text-md-start 
              gap-2 mt-2">

              <p
                class="mb-0 d-flex align-items-center justify-content-center justify-content-md-start gap-2 text-secondary small">
                <span><i class="bi bi-stars"></i></span>
                Powered by AI • Personalized for you
              </p>

              <ng-container *hasPermission="PermissionForStudents.ROADMAP_CREATE">
                <button type="button" class="button btn btn-primary" (click)="onGenerate()" [disabled]="isGenerating">
                  <span><i class="bi bi-magic"></i></span>
                  Generate Roadmap
                </button>
              </ng-container>

            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="tabs-container">
      <div class="tabs-list">
        <button class="tab-btn" [class.active]="selectedTab === roadmapTabStatus.EXPLORE"
          (click)="selectTab(roadmapTabStatus.EXPLORE)">
          <i class="bi bi-map me-2"></i>
          Explore
        </button>

        <button class="tab-btn" [class.active]="selectedTab === roadmapTabStatus.ROADMAP"
          (click)="selectTab(roadmapTabStatus.ROADMAP)">
          <i class="bi bi-arrow-counterclockwise me-2"></i>
          Roadmap
          <span class="badge-count ms-2" *ngIf="myRoadmaps.length > 0">
            {{ myRoadmaps.length }}
          </span>
        </button>
      </div>
    </div>
    <div>
      <div class="course" *ngIf="selectedTab === roadmapTabStatus.EXPLORE">
        <div *ngIf="isPublicRoadmapLoading" class="app-spinner flex-column">
          <mat-spinner diameter="50"></mat-spinner>
        </div>

        <ng-template #roadmapSection let-title="title" let-list="list" let-description="description"
          let-category="category" let-para="para">
          <div *ngIf="!isPublicRoadmapLoading">
            <div class="mt-1 px-2 mb-3">
              <h4 class="fw-semibold">{{ title }}</h4>
              <p class="text-secondary fs-6">{{ description }}</p>

            </div>

            <div class="row g-4 mt-1">
              <div class="col-12 col-sm-6 col-lg-4 my-3" *ngFor="let roadmap of publicRoadmaps">
                <div class="card shadow-sm rounded-3">
                  <div class="d-flex justify-content-center flex-column justify-content-between align-items-center">
                    <div class="card-body d-flex gap-3 p-3 py-4 w-100">
                      <div class="roadmapIcon mt-1 flex-shrink-0">
                        <span class="fs-4 icon-suggested"><i class="bi" [ngClass]=""></i>
                          <i class="bi bi-journal-bookmark"></i>
                        </span>
                      </div>
                      <div class="flex-grow-1 flex-fix">
                        <h5 class="card-title text-truncate fw-medium">
                          {{ roadmap.title }}
                        </h5>

                        <small class="card-text truncate text-secondary">
                          {{ roadmap.description }}
                        </small>
                      </div>
                    </div>
                    <ng-container *hasPermission="PermissionForStudents.ROADMAP_CREATE">
                      <div class="w-100 px-3 pb-3">
                        <button
                          class="generateRoadmapbtn continuebtn w-100 py-2 d-flex justify-content-center align-items-center gap-2"
                          (click)="forkRoadmap(roadmap)" [disabled]="isForking && generatingRoadmap === roadmap.title">
                          <ng-container *ngIf="isForking && generatingRoadmap === roadmap.title">
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            Loading...
                          </ng-container>
                          <ng-container *ngIf="!(isForking && generatingRoadmap === roadmap.title)">
                            View Roadmap
                            <i class="bi bi-arrow-right"></i>
                          </ng-container>
                        </button>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>


              <div class="col-12 text-center mt-3 font-name" *ngIf="hasMorePublic && publicRoadmaps.length >= publicLimit">
                <button class="load-more-btn" (click)="loadMorePublic()" [disabled]="isLoadingMore">
                  <span *ngIf="!isLoadingMore">Load More</span>
                  <span *ngIf="isLoadingMore">
                    <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    Loading...
                  </span>
                </button>
              </div>
            </div>
          </div>
        </ng-template>
        <div style="font-family: 'Poppins', sans-serif;">
        <ng-container *ngTemplateOutlet="
            roadmapSection;
            context: {
              title: 'Suggested Roadmaps',
              description:
                'Explore curated learning paths for popular skills and careers',
              
              category: 'suggested',
            }
          "></ng-container></div>
      </div>
      <div *ngIf="selectedTab === roadmapTabStatus.ROADMAP">
        <div class="course">
          <div *ngIf="isMyRoadmapsLoading" class="app-spinner">
            <mat-spinner diameter="50"></mat-spinner>
          </div>

          <ng-container *ngIf="!isMyRoadmapsLoading">
            <ng-container *ngIf="myRoadmaps.length > 0; else emptyState">

              <div class="d-flex align-items-center justify-content-between myRoadmap font-name">
                <h4 class="fw-semibold">My Roadmaps</h4>
                <div class="d-flex align-items-center gap-2">
                  <div class="search-filter">
                    <div class="search-box">
                      <i class="bi bi-search"></i>
                      <input type="text" placeholder="Search Your Roadmap" [ngModel]="myRoadmapSearch"
                        (ngModelChange)="onSearchChange($event)" />
                    </div>
                  </div>

                  <div class="dropdown font-name">
                    <button class="btn sort-dropdown-toggle px-3" type="button" data-bs-toggle="dropdown"
                      aria-expanded="false">
                      <i class="bi bi-filter-left fs-5 me-2"></i>
                      {{ getSortLabel() }}
                    </button>
                    <ul class="dropdown-menu">
                      <li class="dropdown-item d-flex align-items-center"><i class="bi bi-sort-down"></i><a
                          class="cursor-pointer dropdown-item" (click)="setSort('newest')">Newest First</a></li>
                      <li class="dropdown-item d-flex align-items-center"><i class="bi bi-sort-up"></i><a
                          class="cursor-pointer dropdown-item" (click)="setSort('oldest')">Oldest First</a></li>
                      <li class="dropdown-item d-flex align-items-center"><i class="bi bi-sort-up"></i>
                        <a class="cursor-pointer dropdown-item" (click)="setSort('most-progress')">Most Progress</a>
                      </li>
                      <li class="dropdown-item d-flex align-items-center">
                        <i class="bi bi-sort-up"></i>
                        <a class="cursor-pointer dropdown-item" (click)="setSort('least-progress')">Least Progress</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <!-- Roadmaps List -->
              <div class="row g-4 mt-1 font-name" *ngIf="filteredMyRoadmaps.length > 0; else noResults">
                <div class="col-12 col-sm-6 col-lg-4 my-3" *ngFor="let roadmap of filteredMyRoadmaps">
                  <div class="card shadow-sm rounded-3 h-100">
                    <div class="d-flex justify-content-center flex-column align-items-center position-relative">
                      <!-- Delete Icon -->
                      <!-- we dont have api for this we will do this later -->

                      <!-- <div class="position-absolute top-0 end-0 p-2">
                        <i class="bi bi-trash3 text-danger cursor-pointer"
                          (click)="onDelete(roadmap.roadmap_id, $event)"></i>
                      </div> -->

                      <div class="card-body d-flex gap-3 p-3 w-100 font-name">
                        <div class="roadmapIcon mt-1 flex-shrink-0">
                          <span class="fs-4 icon-suggested">
                            <i class="bi bi-journal-bookmark"></i>
                          </span>
                        </div>
                        <div class="flex-grow-1 flex-fix">
                          <h5 class="card-title text-truncate fw-medium mb-1">
                            {{ roadmap.title }}
                          </h5>
                          <small class="card-text truncate text-secondary mb-2">
                            {{ roadmap.description }}
                          </small>


                          <!-- Progress Section -->
                          <div class="d-flex align-items-center justify-content-between mt-2 font-name">
                            <span class="text-secondary" style="font-size: 11px;">Progress</span>
                            <span class="text-muted extra-small">
                              {{ roadmap.overall_completion_percentage ?? 0 }}%
                            </span>
                          </div>
                          <div class="progress mt-1" style="height: 6px">
                            <div class="progress-bar " style="background-color: #662bcc;"
                              [style.width.%]="roadmap.overall_completion_percentage ?? 0"></div>
                          </div>
                        </div>
                      </div>
                      <div class="w-100 px-3 pb-3 font-name">
                        <button class="generateRoadmapbtn continuebtn w-100 py-2" (click)="viewRoadmap(roadmap)">
                          <ng-container *ngIf="(roadmap.overall_completion_percentage ?? 0) < 100; else completedBtn">
                            Continue
                            <i class="bi bi-arrow-right"></i>
                          </ng-container>
                          <ng-template #completedBtn>
                            Completed
                            <i class="bi bi-check-circle"></i>
                          </ng-template>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-12 text-center mt-3 font-name" *ngIf="hasMoreMy && filteredMyRoadmaps.length >= myLimit">
                  <button class="load-more-btn" (click)="loadMoreMy()" [disabled]="isLoadingMoreMy">
                    <span *ngIf="!isLoadingMoreMy">Load More</span>
                    <span *ngIf="isLoadingMoreMy">
                      <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      Loading...
                    </span>
                  </button>
                </div>
              </div>

              <!-- No Search Results Found -->
              <ng-template #noResults>
                <div class="emptyRoadmap my-4 rounded font-name">
                  <div class="d-flex flex-column justify-content-center align-items-center px-5 py-5">
                    <span class="fs-4">No roadmap found</span>
                    <span class="text-muted d-block">Try adjusting your search terms.</span>

                  </div>
                </div>
              </ng-template>
            </ng-container>

            <ng-template #emptyState>
              <div class="emptyRoadmap my-4 rounded font-name">
                <div class="d-flex flex-column justify-content-center align-items-center px-5 py-5">
                  <span class="fs-4">No Roadmaps yet</span>
                  <span class="text-muted d-block">You haven’t started any roadmap yet.</span>
                  <p class="text-muted">
                    Start by describing your learning goal above!
                  </p>
                </div>
              </div>
            </ng-template>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>